import { useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import './SettingsModal.css';

const DeletePayrollPic = ({ handleClose, show, modalInfo, rowData, onDelete }) => {
    const [modifiedBy, setModifiedBy] = useState('');
    const [status, setStatus] = useState('');

    useEffect(() => {
        console.log(modalInfo);
        console.log(rowData);
        const email = localStorage.getItem('email');
        const username = email.split('@')[0];
        setModifiedBy(username);
        setStatus('0');
    }, [modalInfo, rowData]);

    const deleteFile = () => {
        var isLastItem = false;
        for(let i = 0; i < rowData.length; i++){
            const factoryId = rowData[i].factories.map((item) => item.id).toString();
            const payrollPicId = rowData[i].id;
            if(i == (rowData.length-1)){
                isLastItem = true;
            }
            onDelete({
                status,
                factoryId,
                payrollPicId,
                modifiedBy,
                isLastItem
            });
        }

    };

    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header>
                <Modal.Title
                    className='delete-modal-title'
                    style={{ color: '#c02d2e', marginBottom: '0px' }}
                >
                    Delete Payroll PIC
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>Are you sure you wish to delete this payroll PIC?</Modal.Body>
            <Modal.Footer>
                <Button variant='danger' onClick={deleteFile}>
                    Delete PIC
                </Button>
                <Button variant='outline-secondary' onClick={handleClose}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default DeletePayrollPic;
